(() => {
  const modal = document.getElementById('card-quick-add-modal');
  if (!modal) return;
  const form = modal.querySelector('form');
  const submit = form.querySelector('[type="submit"]');
  const id = form.elements.id;
  const options = form.querySelector('[data-card-quick-add-options]');
  const selection = form.querySelector('[data-card-quick-add-selection]');
  let sourceSection, sourceProduct, product, selected = [], opener, adding = false, ready = false, openingTimer;

  function showError(container, message) {
    const error = container.querySelector('.card-quick-add__error');
    error.textContent = message;
    error.hidden = !message;
  }

  function currentVariant() {
    return product.variants.find(variant => variant.available && variant.options.every((value, index) => value === selected[index]));
  }

  function update() {
    // Later options depend on earlier choices, so changing the first option never
    // traps the customer in a combination that has no available alternatives.
    options.querySelectorAll('[data-option-index]').forEach(button => {
      const index = Number(button.dataset.optionIndex);
      const available = product.variants.some(variant => variant.available && variant.options[index] === button.dataset.value && variant.options.every((value, position) => position >= index || !selected[position] || selected[position] === value));
      button.disabled = adding || !available;
      button.setAttribute('aria-pressed', String(selected[index] === button.dataset.value));
      button.title = available ? button.dataset.value : `${button.dataset.value} — indisponível`;
    });
    const variant = currentVariant();
    id.value = variant ? variant.id : '';
    id.disabled = !variant;
    submit.disabled = adding || !ready || !variant;
    selection.textContent = variant ? `Selecionado: ${selected.join(' / ')}` : 'Selecione todas as opções disponíveis';
  }

  function syncModalColors(card) {
    const styles = getComputedStyle(card);
    ['--quick-add-modal-bg', '--quick-add-modal-text'].forEach(name => {
      const value = styles.getPropertyValue(name).trim();
      if (value) modal.style.setProperty(name, value);
      else modal.style.removeProperty(name);
    });
  }

  function refreshEditorColors() {
    const card = [...document.querySelectorAll('.card-quick-add')].find(element =>
      element.dataset.quickAddSection === sourceSection && element.dataset.quickAddProductId === sourceProduct);
    if (card) {
      syncModalColors(card);
      opener = card.querySelector('[data-card-quick-add]');
    }
    return card;
  }

  function prepare(card, button) {
    ready = false;
    clearTimeout(openingTimer);
    // The native modal registers its focus/close state on visibility transitionend.
    // First-paint or disabled animations may omit that event; complete that same
    // lifecycle once, scoped to this modal, after the normal animation duration.
    openingTimer = setTimeout(() => {
      if (!ready && modal.getAttribute('aria-hidden') === 'false') {
        modal.dispatchEvent(new TransitionEvent('transitionend', { propertyName: 'visibility', bubbles: true }));
      }
    }, 500);
    product = JSON.parse(card.querySelector('[data-card-quick-add-product]').textContent);
    opener = button;
    selected = product.options.map(() => null);
    sourceSection = card.dataset.quickAddSection;
    sourceProduct = card.dataset.quickAddProductId;
    syncModalColors(card);
    modal.querySelector('h2').textContent = product.title;
    const image = modal.querySelector('img');
    image.hidden = !product.image;
    if (product.image) image.src = product.image;
    else image.removeAttribute('src');
    image.alt = product.title;
    options.replaceChildren();
    showError(form, '');
    product.options.forEach((name, index) => {
      const fieldset = document.createElement('fieldset');
      const legend = document.createElement('legend');
      legend.textContent = name;
      const values = document.createElement('div');
      values.className = 'card-quick-add-modal__options';
      [...new Set(product.variants.map(variant => variant.options[index]))].forEach(value => {
        const option = document.createElement('button');
        option.type = 'button';
        option.className = 'card-quick-add-modal__option';
        option.dataset.optionIndex = index;
        option.dataset.value = value;
        option.textContent = value;
        values.append(option);
      });
      fieldset.append(legend, values);
      options.append(fieldset);
    });
    update();
    // Commit the hidden state before the native controller starts its transition.
    modal.getBoundingClientRect();
  }

  // Capture populates the content before the theme's existing open-modal handler.
  document.addEventListener('click', event => {
    const button = event.target.closest('[data-card-quick-add]');
    if (!button || button.disabled) return;
    if (adding) { event.preventDefault(); event.stopImmediatePropagation(); return; }
    const card = button.closest('.card-quick-add');
    const data = JSON.parse(card.querySelector('[data-card-quick-add-product]').textContent);
    if (!data.simple) { prepare(card, button); return; }
    event.preventDefault();
    const variant = data.variants.find(item => item.available);
    if (!variant) return;
    const directForm = document.createElement('form');
    ['id', 'quantity'].forEach(name => {
      const input = document.createElement('input');
      input.name = name;
      input.value = name === 'id' ? variant.id : 1;
      directForm.append(input);
    });
    showError(card, '');
    window.themeCartAdd.add({ form: directForm, button, target: card, variant, onError: message => showError(card, message) });
  }, true);

  options.addEventListener('click', event => {
    const button = event.target.closest('[data-option-index]');
    if (!button || button.disabled || adding) return;
    const index = Number(button.dataset.optionIndex);
    selected[index] = button.dataset.value;
    for (let position = index + 1; position < selected.length; position++) selected[position] = null;
    showError(form, '');
    update();
  });

  function closeBeforeCart() {
    if (modal.getAttribute('aria-hidden') === 'true') return Promise.resolve();
    return new Promise(resolve => {
      modal.addEventListener('modal:closed', resolve, { once: true });
      document.dispatchEvent(new CustomEvent('modal:close'));
    });
  }

  form.addEventListener('submit', async event => {
    event.preventDefault();
    const variant = currentVariant();
    if (!variant || adding || !ready) return;
    adding = true;
    update();
    showError(form, '');
    await window.themeCartAdd.add({ form, button: submit, target: modal, variant,
      beforeAdded: closeBeforeCart, onError: message => showError(form, message) });
    adding = false;
    update();
  });
  modal.addEventListener('modal:closed', () => {
    clearTimeout(openingTimer);
    if (opener && opener.isConnected) opener.focus({ preventScroll: true });
  });
  modal.addEventListener('transitionend', event => {
    if (event.propertyName === 'visibility' && modal.getAttribute('aria-hidden') === 'false') {
      ready = true;
      update();
    }
  });
  document.addEventListener('shopify:section:load', refreshEditorColors);
  document.addEventListener('shopify:section:unload', event => {
    if (opener && event.target.contains(opener)) {
      setTimeout(() => {
        if (!refreshEditorColors()) document.dispatchEvent(new CustomEvent('modal:close'));
      }, 0);
    }
  });
})();
